import React, { useEffect, useState } from "react";
import config from "../../Config";
import axios from "axios";

function LibraryCategorySelect({ value, onChange, name = "txtCategory", required = false, className = "form-control" }) {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const data = {
            AccessKey: localStorage.getItem("AccessKey"),
            UserID: localStorage.getItem("ID"),
            MemberType: localStorage.getItem("MemberType"),
        };

        axios({
            method: "post",
            url: config.base_url + "Library/GetLibraryCategories",
            headers: { "Content-Type": "application/json" },
            data: data,
        })
            .then(function (response) {
                if (response.data.status_code === 1) {
                    setCategories(response.data.Categories || []);
                }
            })
            .catch(function () { });
    }, []);

    return (
        <>
            <input
                type="text"
                name={name}
                className={className}
                list="library-category-list"
                value={value || ""}
                onChange={onChange}
                required={required}
                placeholder="Classification / category"
            />
            <datalist id="library-category-list">
                {categories.map((item, index) => (
                    <option key={index} value={item} />
                ))}
            </datalist>
        </>
    );
}

export default LibraryCategorySelect;
